import { useEffect, useMemo, useState } from "react";
import useIsMobile from "../../../utils/useIsMobile";

export const ServiceBookingStepper = ({ state, dispatch }) => {
   const isMobile = useIsMobile(768)

  const threeStepper = useMemo(()=>{
    return [
      {
        stepNumber : "1",
        title : "Τύπος εργασίας",
      },
      {
        stepNumber : "2",
        title : "Τρόπος εξυπηρέτησης",
      },
      {
        stepNumber : "3",
        title : "Προγραμματισμός ραντεβού",
      },
      {
        stepNumber : "4",
        title : "Πληρωμή",
      }]
    },[state?.stepThree])

    const threeStepperNoPayment = useMemo(()=>{
    return [{
      stepNumber : "1",
      title : "Τύπος εργασίας",
    },
    {
      stepNumber : "2",
      title : "Τρόπος εξυπηρέτησης",
    },
    {
      stepNumber : "3",
      title : "Προγραμματισμός Ραντεβού",
    }]
  },[state?.stepThree])

  const fourStepper = useMemo(() =>{
    return [{
        stepNumber : "1",
        title : "Τύπος εργασίας",
      },
      {
        stepNumber : "2",
        title : "Τρόπος εξυπηρέτησης",},
      {
        stepNumber : "3",
        title : "Προγραμματισμός Ραντεβού",},
      {
        stepNumber : "4",
        title : "Επιπλέον πληροφορίες",
      },
      {
        stepNumber : "5",
        title : "Πληρωμή",
      }]
  },[state?.stepThree])

    const fourStepperNoPayment = useMemo(() =>{
    return [{
        stepNumber : "1",
        title : "Τύπος εργασίας",
      },
      {
        stepNumber : "2",
        title : "Τρόπος εξυπηρέτησης",},
      {
        stepNumber : "3",
        title : "Προγραμματισμός Ραντεβού",},
      {
        stepNumber : "4",
        title : "Επιπλέον πληροφορίες",
      }]
  },[state?.stepThree])


  const gradientStepStops = {
    1 : [
          "#FFD0DB 13%",
          "#F5F5F7 23%",
        ],
    2 : [
          "#FFD0DB 35%",
          "#F5F5F7 50%",
        ],
    3 : [
          "#FFD0DB 50%",
          "#F5F5F7 80%",
        ],
    4 : [
          "#FFD0DB 70%",
          "#FFD0DB 100%",
        ],  
    5 : [
          "#FFD0DB 90%",
          "#FFD0DB 100%",
        ], 
    }

  const gradientStepStopsMobile = {
    1 : [
          "#FFD0DB 15%",
          "#FFFFFF 30%",
        ],
    2 : [
          "#FFD0DB 35%",
          "#FFFFFF 55%",
        ],
    3 : [
          "#FFD0DB 55%",
          "#FFFFFF 80%",
        ],
    4 : [
          "#FFD0DB 70%",
          "#FFD0DB 100%",
        ],  
    5 : [
          "#FFD0DB 85%",
          "#FFD0DB 100%",
        ], 
    }

  const gradient = `linear-gradient(${isMobile ? "to bottom" : "to right"}, ${isMobile ? gradientStepStopsMobile[state?.step].join(", ") : gradientStepStops[state?.step].join(", ")})`;


  const [stepTitles, setStepTitles] = useState(fourStepper)

  useEffect(()=>{
    if(state?.isAuthorizedEV 
      // && !state?.serviceLightIndicator
      && state?.options?.standarizedService === true 
      && state?.options?.bodyWork === false 
      && state?.options?.tyresChange === false) {
        if((state?.selectedPickup && state?.pickupCost === 0) || !state?.selectedPickup){
          setStepTitles(threeStepperNoPayment)
        } else {
          setStepTitles(threeStepper)
        }
      } else {
        if((state?.selectedPickup && state?.pickupCost === 0) || !state?.selectedPickup){
          setStepTitles(fourStepperNoPayment)
        } else {
          setStepTitles(fourStepper)
        }
      }
  }, [fourStepper, fourStepperNoPayment, state?.isAuthorizedEV, state?.options, state?.pickupCost, state?.selectedPickup, state.stepThree, threeStepper, threeStepperNoPayment])

  return (
    <div className="py-4 flex justify-center w-full md:px-10">
      <div className={`flex w-[90vw] pr-3 ${isMobile ? "flex-col rounded-xl items-start" : "flex-row rounded-full items-center"} justify-between overflow-hidden`} 
        style={{ backgroundImage: gradient }}>

        {stepTitles.map((step) => (
          <div className='flex flex-row gap-3 items-center p-2' key={step.stepNumber}>
            <div className={`flex items-center justify-center w-[24px] h-[24px] rounded-full ${parseInt(step?.stepNumber) < state?.step ? "bg-midgrey" : parseInt(step?.stepNumber) === state?.step ? "bg-primary" : "bg-fadedgrey"} text-white font-bold`}>
              <p>{step?.stepNumber}</p>
            </div>
            <p className='text-sm font-[600]'>{step?.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
